import { ReactComponent as Lock } from "../svgs/lock.svg";
import { ReactComponent as Logo } from "../svgs/logo.svg";
import { ReactComponent as Kaaba1 } from "../svgs/kaaba-01.svg";
import { ReactComponent as Mosque2 } from "../svgs/mosque-02.svg";
import { ReactComponent as UserSearch1 } from "../svgs/user-search-01.svg";
import { ReactComponent as UserGroup } from "../svgs/user-group.svg";
import { ReactComponent as UserUnlock01 } from "../svgs/user-unlock-01.svg";
import { ReactComponent as AddTeam } from "../svgs/add-team.svg";
import { ReactComponent as UserAdd02 } from "../svgs/user-add-02.svg";
import { ReactComponent as ThreeDots } from "../svgs/three-dots.svg";
import { ReactComponent as FileExcel } from "../svgs/xsl-02.svg";
// New selected state icons
import { ReactComponent as KaabaIcon } from "../svgs/kaaba-icon.svg";
import { ReactComponent as MosqueMadinaIcon } from "../svgs/mosque-madina-icon.svg";
import { ReactComponent as UserSerachIcon } from "../svgs/user-serach-icon.svg";
import { ReactComponent as UserUnlockIcon } from "../svgs/user-unlock-icon.svg";

export const LockIcon = (props) => {
  return <Lock {...props} />;
};
export const LogoIcon = (props) => {
  return <Logo {...props} />;
};
export const Kaaba1Icon = (props) => {
  return <Kaaba1 {...props} />;
};
export const Mosque2Icon = (props) => {
  return <Mosque2 {...props} />;
};
export const UserSearch1Icon = (props) => {
  return <UserSearch1 {...props} />;
};
export const UserGroupIcon = (props) => {
  return <UserGroup {...props} />;
};
export const UserUnlock01Icon = (props) => {
  return <UserUnlock01 {...props} />;
};
export const UserAdd02Icon = (props) => {
  return <UserAdd02 {...props} />;
};
export const AddTeamIcon = (props) => {
  return <AddTeam {...props} />;
};
export const ThreeDotsIcon = (props) => {
  return <ThreeDots {...props} />;
};

// New selected state icons
export const KaabaSelectedIcon = (props) => {
  return <KaabaIcon {...props} />;
};
export const MosqueMadinaSelectedIcon = (props) => {
  return <MosqueMadinaIcon {...props} />;
};
export const UserSerachSelectedIcon = (props) => {
  return <UserSerachIcon {...props} />;
};
export const UserUnlockSelectedIcon = (props) => {
  return <UserUnlockIcon {...props} />;
};
export const FileExcelIcon = (props) => {
  return <FileExcel {...props} />;
};
